module.exports = __webpack_public_path__ + "img/upcoming-auction-3.4db73998.png";